import { tmsApi as api } from "./tmsApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAdmintoolMarkets: build.query<
      GetAdmintoolMarketsApiResponse,
      GetAdmintoolMarketsApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    postAdmintoolMarkets: build.mutation<
      PostAdmintoolMarketsApiResponse,
      PostAdmintoolMarketsApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets`,
        method: "POST",
        body: queryArg.adminNatCodesNewMarketRequest,
      }),
    }),
    getAdmintoolMarketsByMarketId: build.query<
      GetAdmintoolMarketsByMarketIdApiResponse,
      GetAdmintoolMarketsByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    putAdmintoolMarketsByMarketId: build.mutation<
      PutAdmintoolMarketsByMarketIdApiResponse,
      PutAdmintoolMarketsByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}`,
        method: "PUT",
        body: queryArg.adminNatCodesMarketDescription,
        params: {
          replace: queryArg.replace,
        },
      }),
    }),
    deleteAdmintoolMarketsByMarketId: build.mutation<
      DeleteAdmintoolMarketsByMarketIdApiResponse,
      DeleteAdmintoolMarketsByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}`,
        method: "DELETE",
      }),
    }),
    getAdmintoolMarketsByMarketIdFactoryCodeAttrs: build.query<
      GetAdmintoolMarketsByMarketIdFactoryCodeAttrsApiResponse,
      GetAdmintoolMarketsByMarketIdFactoryCodeAttrsApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/factory_code_attrs`,
      }),
    }),
    putAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemId:
      build.mutation<
        PutAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse,
        PutAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/factory_code_attrs/${queryArg.factoryCodeItemId}`,
          method: "PUT",
          body: queryArg.factoryCodeAttributeRequest,
        }),
      }),
    postAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemId:
      build.mutation<
        PostAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse,
        PostAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/factory_code_attrs/${queryArg.factoryCodeItemId}`,
          method: "POST",
          body: queryArg.factoryCodeAttributeRequest,
        }),
      }),
    deleteAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemId:
      build.mutation<
        DeleteAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse,
        DeleteAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/factory_code_attrs/${queryArg.factoryCodeItemId}`,
          method: "DELETE",
        }),
      }),
    postAdmintoolMarketsByMarketIdGroups: build.mutation<
      PostAdmintoolMarketsByMarketIdGroupsApiResponse,
      PostAdmintoolMarketsByMarketIdGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/groups`,
        method: "POST",
        body: queryArg.adminNatCodesNewGroupRequest,
      }),
    }),
    getAdmintoolMarketsByMarketIdGroupsAndGroupId: build.query<
      GetAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse,
      GetAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    putAdmintoolMarketsByMarketIdGroupsAndGroupId: build.mutation<
      PutAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse,
      PutAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}`,
        method: "PUT",
        body: queryArg.adminNatCodesGroupDescription,
        params: {
          replace: queryArg.replace,
        },
      }),
    }),
    deleteAdmintoolMarketsByMarketIdGroupsAndGroupId: build.mutation<
      DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse,
      DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}`,
        method: "DELETE",
      }),
    }),
    postAdmintoolMarketsByMarketIdGroupsAndGroupIdFamilies: build.mutation<
      PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiResponse,
      PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families`,
        method: "POST",
        body: queryArg.adminNatCodesNewFamilyRequest,
      }),
    }),
    getAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyId: build.query<
      GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse,
      GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}`,
        params: {
          recursive: queryArg.recursive,
          languageId: queryArg.languageId,
        },
      }),
    }),
    putAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyId:
      build.mutation<
        PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse,
        PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}`,
          method: "PUT",
          body: queryArg.adminNatCodesFamilyDescription,
          params: {
            replace: queryArg.replace,
          },
        }),
      }),
    deleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyId:
      build.mutation<
        DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse,
        DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}`,
          method: "DELETE",
        }),
      }),
    postAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutions:
      build.mutation<
        PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiResponse,
        PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions`,
          method: "POST",
          body: queryArg.adminNatCodesNewCodeRequest,
        }),
      }),
    getAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionId:
      build.query<
        GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse,
        GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions/${queryArg.executionId}`,
          params: {
            languageId: queryArg.languageId,
          },
        }),
      }),
    putAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionId:
      build.mutation<
        PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse,
        PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions/${queryArg.executionId}`,
          method: "PUT",
          body: queryArg.adminNatCodesCodeDescription,
          params: {
            replace: queryArg.replace,
          },
        }),
      }),
    deleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionId:
      build.mutation<
        DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse,
        DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/groups/${queryArg.groupId}/families/${queryArg.familyId}/executions/${queryArg.executionId}`,
          method: "DELETE",
        }),
      }),
    getAdmintoolMarketsByMarketIdImportantFamiliesCountry: build.query<
      GetAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse,
      GetAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/importantFamiliesCountry`,
      }),
    }),
    putAdmintoolMarketsByMarketIdImportantFamiliesCountry: build.mutation<
      PutAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse,
      PutAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/importantFamiliesCountry`,
        method: "PUT",
        body: queryArg.importantFamiliesCountryRequest,
      }),
    }),
    getAdmintoolMarketsByMarketIdReferenceTrucks: build.query<
      GetAdmintoolMarketsByMarketIdReferenceTrucksApiResponse,
      GetAdmintoolMarketsByMarketIdReferenceTrucksApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/reference_trucks`,
      }),
    }),
    postAdmintoolMarketsByMarketIdReferenceTrucks: build.mutation<
      PostAdmintoolMarketsByMarketIdReferenceTrucksApiResponse,
      PostAdmintoolMarketsByMarketIdReferenceTrucksApiArg
    >({
      query: (queryArg) => ({
        url: `/admintool/markets/${queryArg.marketId}/reference_trucks`,
        method: "POST",
        body: queryArg.newReferenceTruckRequest,
      }),
    }),
    getAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckId:
      build.query<
        GetAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse,
        GetAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/reference_trucks/${queryArg.referenceTruckId}`,
        }),
      }),
    putAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckId:
      build.mutation<
        PutAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse,
        PutAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/reference_trucks/${queryArg.referenceTruckId}`,
          method: "PUT",
          body: queryArg.updateReferenceTruckRequest,
        }),
      }),
    deleteAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckId:
      build.mutation<
        DeleteAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse,
        DeleteAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admintool/markets/${queryArg.marketId}/reference_trucks/${queryArg.referenceTruckId}`,
          method: "DELETE",
        }),
      }),
    postCava: build.mutation<PostCavaApiResponse, PostCavaApiArg>({
      query: (queryArg) => ({
        url: `/cava`,
        method: "POST",
        body: queryArg.cavaProvisionedRequest,
      }),
    }),
    postCavaByUuid: build.mutation<
      PostCavaByUuidApiResponse,
      PostCavaByUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/cava/${queryArg.uuid}`,
        method: "POST",
        body: queryArg.cavaRequest,
      }),
    }),
    postCode: build.mutation<PostCodeApiResponse, PostCodeApiArg>({
      query: (queryArg) => ({
        url: `/code`,
        method: "POST",
        body: queryArg.manCodeRequest,
      }),
    }),
    getCodeById: build.query<GetCodeByIdApiResponse, GetCodeByIdApiArg>({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}`,
        params: {
          include_journal: queryArg.includeJournal,
        },
      }),
    }),
    getCodeByIdCheck: build.query<
      GetCodeByIdCheckApiResponse,
      GetCodeByIdCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}/check`,
        params: {
          partPeriod: queryArg.partPeriod,
          executeFinalChecks: queryArg.executeFinalChecks,
          checkAccpetanceLevel: queryArg.checkAccpetanceLevel,
        },
      }),
    }),
    putCodeByIdConfiguration: build.mutation<
      PutCodeByIdConfigurationApiResponse,
      PutCodeByIdConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}/configuration`,
        method: "PUT",
        body: queryArg.manCodeRequest,
        params: {
          system: queryArg.system,
        },
      }),
    }),
    postCodeByIdCopy: build.mutation<
      PostCodeByIdCopyApiResponse,
      PostCodeByIdCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}/copy`,
        method: "POST",
      }),
    }),
    getCodeByIdGetTokensAndSystem: build.query<
      GetCodeByIdGetTokensAndSystemApiResponse,
      GetCodeByIdGetTokensAndSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}/getTokens/${queryArg.system}`,
      }),
    }),
    putCodeByIdResetTokensAndSystem: build.mutation<
      PutCodeByIdResetTokensAndSystemApiResponse,
      PutCodeByIdResetTokensAndSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}/resetTokens/${queryArg.system}`,
        method: "PUT",
      }),
    }),
    putCodeByIdSetTokens: build.mutation<
      PutCodeByIdSetTokensApiResponse,
      PutCodeByIdSetTokensApiArg
    >({
      query: (queryArg) => ({
        url: `/code/${queryArg.id}/setTokens`,
        method: "PUT",
        body: queryArg.tokenRequest,
      }),
    }),
    postConfiguration: build.mutation<
      PostConfigurationApiResponse,
      PostConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration`,
        method: "POST",
        body: queryArg.ecmConfigurationTarget,
      }),
    }),
    getConfigurationByUuid: build.query<
      GetConfigurationByUuidApiResponse,
      GetConfigurationByUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}`,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    putConfigurationByUuidChangeGroupOfInterest: build.mutation<
      PutConfigurationByUuidChangeGroupOfInterestApiResponse,
      PutConfigurationByUuidChangeGroupOfInterestApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/change_group_of_interest`,
        method: "PUT",
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    getConfigurationByUuidCheckBrakeRatio: build.query<
      GetConfigurationByUuidCheckBrakeRatioApiResponse,
      GetConfigurationByUuidCheckBrakeRatioApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/check_brake_ratio`,
      }),
    }),
    getConfigurationByUuidCheckDvs: build.query<
      GetConfigurationByUuidCheckDvsApiResponse,
      GetConfigurationByUuidCheckDvsApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/check_dvs`,
      }),
    }),
    getConfigurationByUuidCheckOas: build.query<
      GetConfigurationByUuidCheckOasApiResponse,
      GetConfigurationByUuidCheckOasApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/check_oas`,
        params: {
          check_type: queryArg.checkType,
        },
      }),
    }),
    getConfigurationByUuidCheckTires: build.query<
      GetConfigurationByUuidCheckTiresApiResponse,
      GetConfigurationByUuidCheckTiresApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/check_tires`,
      }),
    }),
    getConfigurationByUuidCheckWeight: build.query<
      GetConfigurationByUuidCheckWeightApiResponse,
      GetConfigurationByUuidCheckWeightApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/check_weight`,
      }),
    }),
    postConfigurationByUuidDeselectVariants: build.mutation<
      PostConfigurationByUuidDeselectVariantsApiResponse,
      PostConfigurationByUuidDeselectVariantsApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/deselect-variants`,
        method: "POST",
        body: queryArg.multiVariantDeselectionRequest,
      }),
    }),
    putConfigurationByUuidRefresh: build.mutation<
      PutConfigurationByUuidRefreshApiResponse,
      PutConfigurationByUuidRefreshApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/refresh`,
        method: "PUT",
      }),
    }),
    postConfigurationByUuidSelectVariantAndVariantId: build.mutation<
      PostConfigurationByUuidSelectVariantAndVariantIdApiResponse,
      PostConfigurationByUuidSelectVariantAndVariantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/select-variant/${queryArg["variant-id"]}`,
        method: "POST",
        body: queryArg.variantSelectionOptions,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    postConfigurationByUuidSelectVariants: build.mutation<
      PostConfigurationByUuidSelectVariantsApiResponse,
      PostConfigurationByUuidSelectVariantsApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/select-variants`,
        method: "POST",
        body: queryArg.multiVariantSelectionRequest,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    postConfigurationByUuidStepAndStep: build.mutation<
      PostConfigurationByUuidStepAndStepApiResponse,
      PostConfigurationByUuidStepAndStepApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/step/${queryArg.step}`,
        method: "POST",
        body: queryArg.configurationStepDataOptions,
        params: {
          groupForCompatibilityCheck: queryArg.groupForCompatibilityCheck,
        },
      }),
    }),
    putConfigurationByUuidSwitchBaseParameters: build.mutation<
      PutConfigurationByUuidSwitchBaseParametersApiResponse,
      PutConfigurationByUuidSwitchBaseParametersApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/switch_base_parameters`,
        method: "PUT",
        body: queryArg.switchBaseParametersRequest,
      }),
    }),
    postConfigurationByUuidUndocommit: build.mutation<
      PostConfigurationByUuidUndocommitApiResponse,
      PostConfigurationByUuidUndocommitApiArg
    >({
      query: (queryArg) => ({
        url: `/configuration/${queryArg.uuid}/undocommit`,
        method: "POST",
        body: queryArg.configurationStepDataOptions,
      }),
    }),
    postConvertEcmConfigByUuid: build.mutation<
      PostConvertEcmConfigByUuidApiResponse,
      PostConvertEcmConfigByUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/convert/ecm_config/${queryArg.uuid}`,
        method: "POST",
        body: queryArg.ecmConversionTarget,
      }),
    }),
    postConvertMancode: build.mutation<
      PostConvertMancodeApiResponse,
      PostConvertMancodeApiArg
    >({
      query: (queryArg) => ({
        url: `/convert/mancode`,
        method: "POST",
        body: queryArg.manConversionTarget,
      }),
    }),
    postConvertTg3CodeByLanguage: build.mutation<
      PostConvertTg3CodeByLanguageApiResponse,
      PostConvertTg3CodeByLanguageApiArg
    >({
      query: (queryArg) => ({
        url: `/convert/tg3code/${queryArg.language}`,
        method: "POST",
        body: queryArg.tg3ConversionRequest,
        params: {
          addEmptyGroups: queryArg.addEmptyGroups,
          addEmptyFamilies: queryArg.addEmptyFamilies,
          excludeHiddenCodes: queryArg.excludeHiddenCodes,
          excludeIneffectiveCodes: queryArg.excludeIneffectiveCodes,
          addFPCMapping: queryArg.addFpcMapping,
          viewId: queryArg.viewId,
        },
      }),
    }),
    getProductdataGetconfigurationtypeids: build.query<
      GetProductdataGetconfigurationtypeidsApiResponse,
      GetProductdataGetconfigurationtypeidsApiArg
    >({
      query: () => ({ url: `/productdata/getconfigurationtypeids` }),
    }),
    getProductdataGetvehicletypeids: build.query<
      GetProductdataGetvehicletypeidsApiResponse,
      GetProductdataGetvehicletypeidsApiArg
    >({
      query: () => ({ url: `/productdata/getvehicletypeids` }),
    }),
    getProductdataGetviewheadersByMarketId: build.query<
      GetProductdataGetviewheadersByMarketIdApiResponse,
      GetProductdataGetviewheadersByMarketIdApiArg
    >({
      query: (queryArg) => ({
        url: `/productdata/getviewheaders/${queryArg.marketId}`,
      }),
    }),
    getProductdataImportantFamiliesFactory: build.query<
      GetProductdataImportantFamiliesFactoryApiResponse,
      GetProductdataImportantFamiliesFactoryApiArg
    >({
      query: () => ({ url: `/productdata/importantFamiliesFactory` }),
    }),
    getProductdataMarketByMarketIdLanguageAndLanguageIdFamilies: build.query<
      GetProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiResponse,
      GetProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiArg
    >({
      query: (queryArg) => ({
        url: `/productdata/market/${queryArg.marketId}/language/${queryArg.languageId}/families`,
        params: {
          includeOnlyLocalCodes: queryArg.includeOnlyLocalCodes,
          viewId: queryArg.viewId,
        },
      }),
    }),
    getProductdataMarketByMarketIdLanguages: build.query<
      GetProductdataMarketByMarketIdLanguagesApiResponse,
      GetProductdataMarketByMarketIdLanguagesApiArg
    >({
      query: (queryArg) => ({
        url: `/productdata/market/${queryArg.marketId}/languages`,
      }),
    }),
    getProductdataMarketByMarketIdPartPeriodFromDesiredDealerDate: build.query<
      GetProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiResponse,
      GetProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiArg
    >({
      query: (queryArg) => ({
        url: `/productdata/market/${queryArg.marketId}/partPeriodFromDesiredDealerDate`,
        params: {
          vehicleTypeId: queryArg.vehicleTypeId,
          desiredDealerDate: queryArg.desiredDealerDate,
        },
      }),
    }),
    getTg3CodeById: build.query<
      GetTg3CodeByIdApiResponse,
      GetTg3CodeByIdApiArg
    >({
      query: (queryArg) => ({ url: `/tg3_code/${queryArg.id}` }),
    }),
    getUserdataGetmarkets: build.query<
      GetUserdataGetmarketsApiResponse,
      GetUserdataGetmarketsApiArg
    >({
      query: () => ({ url: `/userdata/getmarkets` }),
    }),
    getUserdataLoad: build.query<
      GetUserdataLoadApiResponse,
      GetUserdataLoadApiArg
    >({
      query: () => ({ url: `/userdata/load` }),
    }),
    postUserdataUpdate: build.mutation<
      PostUserdataUpdateApiResponse,
      PostUserdataUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/userdata/update`,
        method: "POST",
        body: queryArg.userData,
      }),
    }),
    getTokenManagement: build.query<
      GetTokenManagementApiResponse,
      GetTokenManagementApiArg
    >({
      query: () => ({ url: `/token-management` }),
    }),
    postUnittesting: build.mutation<
      PostUnittestingApiResponse,
      PostUnittestingApiArg
    >({
      query: () => ({ url: `/unittesting`, method: "POST" }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as tmsApiService };
export type GetAdmintoolMarketsApiResponse =
  /** status 200 OK */ AdminAllMarketsResponse;
export type GetAdmintoolMarketsApiArg = {
  /** Indicates if attached groups, families, and codes should also be included in the response */
  recursive?: boolean;
  /** Indicates which language should be chosen for the returned description of the market items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
  languageId?: LanguageIsoCode;
};
export type PostAdmintoolMarketsApiResponse =
  /** status 201 CREATED */ AdminMarketDescriptionResponse;
export type PostAdmintoolMarketsApiArg = {
  adminNatCodesNewMarketRequest: AdminNatCodesNewMarketRequest;
};
export type GetAdmintoolMarketsByMarketIdApiResponse =
  /** status 200 OK */ AdminMarketDescriptionResponse;
export type GetAdmintoolMarketsByMarketIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Indicates if attached groups, families, and codes should also be included in the response */
  recursive?: boolean;
  /** Indicates which language should be chosen for the returned description of the market items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
  languageId?: LanguageIsoCode;
};
export type PutAdmintoolMarketsByMarketIdApiResponse =
  /** status 200 OK */ AdminMarketDescriptionResponse;
export type PutAdmintoolMarketsByMarketIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Indicates whether to replace all market information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
  replace?: string;
  adminNatCodesMarketDescription: AdminNatCodesMarketDescription;
};
export type DeleteAdmintoolMarketsByMarketIdApiResponse =
  /** status 200 OK */ AdminStatusResponse;
export type DeleteAdmintoolMarketsByMarketIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type GetAdmintoolMarketsByMarketIdFactoryCodeAttrsApiResponse =
  /** status 200 OK */ AdminAllFactoryCodeAttributesResponse;
export type GetAdmintoolMarketsByMarketIdFactoryCodeAttrsApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type PutAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse =
  /** status 200 OK */ AdminFactoryCodeAttributesResponse;
export type PutAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target factory code attributes entry */
    factoryCodeItemId: FactoryCodeItemId;
    factoryCodeAttributeRequest: FactoryCodeAttributeRequest;
  };
export type PostAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse =
  /** status 200 OK */ AdminFactoryCodeAttributesResponse;
export type PostAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target factory code attributes entry by familyId or variantId. */
    factoryCodeItemId: FactoryCodeItemId;
    factoryCodeAttributeRequest: FactoryCodeAttributeRequest;
  };
export type DeleteAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiResponse =
  /** status 200 OK */ AdminStatusResponse;
export type DeleteAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target factory code attributes entry */
    factoryCodeItemId: FactoryCodeItemId;
  };
export type PostAdmintoolMarketsByMarketIdGroupsApiResponse =
  /** status 201 CREATED */ AdminNatCodesGroupDescriptionResponse;
export type PostAdmintoolMarketsByMarketIdGroupsApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  adminNatCodesNewGroupRequest: AdminNatCodesNewGroupRequest;
};
export type GetAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse =
  /** status 200 OK */ AdminNatCodesGroupDescriptionResponse;
export type GetAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg = {
  /** Indicates if attached families and codes should also be included in the response */
  recursive?: boolean;
  /** Indicates which language should be chosen for the returned description of the group items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
  languageId?: LanguageIsoCode;
  /** Identifies the target market */
  marketId: MarketId;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
};
export type PutAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse =
  /** status 200 OK */ AdminNatCodesGroupDescriptionResponse;
export type PutAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Indicates whether to replace all group information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
  replace?: string;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
  adminNatCodesGroupDescription: AdminNatCodesGroupDescription;
};
export type DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdApiResponse =
  /** status 200 OK */ AdminStatusResponse;
export type DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
};
export type PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiResponse =
  /** status 201 CREATED */ AdminNatCodesFamilyDescriptionResponse;
export type PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  /** Identifies the target group */
  groupId: AdminNatCodesGroupId;
  adminNatCodesNewFamilyRequest: AdminNatCodesNewFamilyRequest;
};
export type GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse =
  /** status 200 OK */ AdminNatCodesFamilyDescriptionResponse;
export type GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg =
  {
    /** Indicates if attached codes should also be included in the response */
    recursive?: boolean;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Indicates which language should be chosen for the returned description of the family items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
    languageId?: LanguageIsoCode;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse =
  /** status 200 OK */ AdminNatCodesFamilyDescriptionResponse;
export type PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg =
  {
    /** Indicates whether to replace all family information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
    replace?: string;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
    adminNatCodesFamilyDescription: AdminNatCodesFamilyDescription;
  };
export type DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiResponse =
  /** status 200 OK */ AdminStatusResponse;
export type DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiResponse =
  /** status 201 CREATED */ AdminNatCodesCodeDescriptionResponse;
export type PostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
    adminNatCodesNewCodeRequest: AdminNatCodesNewCodeRequest;
  };
export type GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse =
  /** status 200 OK */ AdminNatCodesCodeDescriptionResponse;
export type GetAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg =
  {
    /** Identifies the target execution */
    executionId: AdminNatCodesExecutionId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Indicates which language should be chosen for the returned description of the code items. If no language is specified, descriptions in all available languages will be returned. If there is no description available for a certain item in the specified language, no description will be returned */
    languageId?: LanguageIsoCode;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse =
  /** status 200 OK */ AdminNatCodesCodeDescriptionResponse;
export type PutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg =
  {
    /** Identifies the target execution */
    executionId: AdminNatCodesExecutionId;
    /** Indicates whether to replace all code information or rather incorporate new information. This is helpful if e.g. a description in an additional language is to be added. */
    replace?: string;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
    adminNatCodesCodeDescription: AdminNatCodesCodeDescription;
  };
export type DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiResponse =
  /** status 200 OK */ AdminStatusResponse;
export type DeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdApiArg =
  {
    /** Identifies the target execution */
    executionId: AdminNatCodesExecutionId;
    /** Identifies the target family */
    familyId: AdminNatCodesFamilyId;
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target group */
    groupId: AdminNatCodesGroupId;
  };
export type GetAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse =
  /** status 200 OK */ ImportantFamiliesCountryResponse;
export type GetAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type PutAdmintoolMarketsByMarketIdImportantFamiliesCountryApiResponse =
  /** status 200 OK */ ImportantFamiliesCountryResponse;
export type PutAdmintoolMarketsByMarketIdImportantFamiliesCountryApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  importantFamiliesCountryRequest: ImportantFamiliesCountryRequest;
};
export type GetAdmintoolMarketsByMarketIdReferenceTrucksApiResponse =
  /** status 200 OK */ AdminAllReferenceTrucksResponse;
export type GetAdmintoolMarketsByMarketIdReferenceTrucksApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
};
export type PostAdmintoolMarketsByMarketIdReferenceTrucksApiResponse =
  /** status 201 CREATED */ AdminReferenceTrucksResponse;
export type PostAdmintoolMarketsByMarketIdReferenceTrucksApiArg = {
  /** Identifies the target market */
  marketId: MarketId;
  newReferenceTruckRequest: NewReferenceTruckRequest;
};
export type GetAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse =
  /** status 200 OK */ AdminReferenceTrucksResponse;
export type GetAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target reference Truck */
    referenceTruckId: ReferenceTuckId;
  };
export type PutAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse =
  /** status 200 OK */ AdminReferenceTrucksResponse;
export type PutAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target reference Truck */
    referenceTruckId: ReferenceTuckId;
    updateReferenceTruckRequest: UpdateReferenceTruckRequest;
  };
export type DeleteAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiResponse =
  /** status 200 OK */ AdminStatusResponse;
export type DeleteAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdApiArg =
  {
    /** Identifies the target market */
    marketId: MarketId;
    /** Identifies the target reference Truck */
    referenceTruckId: ReferenceTuckId;
  };
export type PostCavaApiResponse = /** status 200 OK */ CavaResponse;
export type PostCavaApiArg = {
  cavaProvisionedRequest: CavaProvisionedRequest;
};
export type PostCavaByUuidApiResponse = /** status 200 OK */ CavaResponse;
export type PostCavaByUuidApiArg = {
  uuid: EcmConfigId;
  cavaRequest: CavaRequest;
};
export type PostCodeApiResponse = /** status 201 CREATED */ CodeCreatedResponse;
export type PostCodeApiArg = {
  manCodeRequest: ManCodeRequest;
};
export type GetCodeByIdApiResponse = /** status 200 OK */ ManCodeResponse;
export type GetCodeByIdApiArg = {
  /** Indicates whether to include the MANCode's journal in the response */
  includeJournal?: boolean;
  id: ManCodeId;
};
export type GetCodeByIdCheckApiResponse =
  /** status 200 OK */ CheckCodeResponse;
export type GetCodeByIdCheckApiArg = {
  /** Response to conversion request from desired dealer date to part period */
  partPeriod?: Period;
  /** Indicates whether to conduct final checks on the configuration */
  executeFinalChecks?: boolean;
  /** Specifies which final check outcome levels to accept. This parameter only takes effect if executeFinalChecks is set to true */
  checkAccpetanceLevel?: "Green" | "Yellow";
  id: ManCodeId;
};
export type PutCodeByIdConfigurationApiResponse =
  /** status 201 CREATED */ ErrorResponse;
export type PutCodeByIdConfigurationApiArg = {
  system: QueryParameterSystem;
  id: ManCodeId;
  manCodeRequest: ManCodeRequest;
};
export type PostCodeByIdCopyApiResponse =
  /** status 201 CREATED */ ManCodeResponse;
export type PostCodeByIdCopyApiArg = {
  id: ManCodeId;
};
export type GetCodeByIdGetTokensAndSystemApiResponse =
  /** status 201 CREATED */ SystemListResponse;
export type GetCodeByIdGetTokensAndSystemApiArg = {
  system: QueryParameterSystem;
  id: ManCodeId;
};
export type PutCodeByIdResetTokensAndSystemApiResponse =
  /** status 201 CREATED */ StatusResponse;
export type PutCodeByIdResetTokensAndSystemApiArg = {
  system: QueryParameterSystem;
  id: ManCodeId;
};
export type PutCodeByIdSetTokensApiResponse =
  /** status 201 CREATED */ StatusResponse;
export type PutCodeByIdSetTokensApiArg = {
  id: ManCodeId;
  tokenRequest: TokenRequest;
};
export type PostConfigurationApiResponse = /** status 200 OK */ Configuration;
export type PostConfigurationApiArg = {
  ecmConfigurationTarget: EcmConfigurationTarget;
};
export type GetConfigurationByUuidApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type GetConfigurationByUuidApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
};
export type PutConfigurationByUuidChangeGroupOfInterestApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PutConfigurationByUuidChangeGroupOfInterestApiArg = {
  groupForCompatibilityCheck: ProductGroupId;
  uuid: EcmConfigId;
};
export type GetConfigurationByUuidCheckBrakeRatioApiResponse =
  /** status 200 OK */ BrakeCheckResponse;
export type GetConfigurationByUuidCheckBrakeRatioApiArg = {
  uuid: EcmConfigId;
};
export type GetConfigurationByUuidCheckDvsApiResponse =
  /** status 200 OK */ DvsCheckResponse;
export type GetConfigurationByUuidCheckDvsApiArg = {
  uuid: EcmConfigId;
};
export type GetConfigurationByUuidCheckOasApiResponse =
  /** status 200 OK */ OasCheckResponse;
export type GetConfigurationByUuidCheckOasApiArg = {
  checkType: OasCheckType;
  uuid: EcmConfigId;
};
export type GetConfigurationByUuidCheckTiresApiResponse =
  /** status 200 OK */ TireCheckResponse;
export type GetConfigurationByUuidCheckTiresApiArg = {
  uuid: EcmConfigId;
};
export type GetConfigurationByUuidCheckWeightApiResponse =
  /** status 200 OK */ WeightCheckResponse;
export type GetConfigurationByUuidCheckWeightApiArg = {
  uuid: EcmConfigId;
};
export type PostConfigurationByUuidDeselectVariantsApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostConfigurationByUuidDeselectVariantsApiArg = {
  uuid: EcmConfigId;
  multiVariantDeselectionRequest: MultiVariantDeselectionRequest;
};
export type PutConfigurationByUuidRefreshApiResponse =
  /** status 200 OK */ RefreshConfigurationResponse;
export type PutConfigurationByUuidRefreshApiArg = {
  uuid: EcmConfigId;
};
export type PostConfigurationByUuidSelectVariantAndVariantIdApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostConfigurationByUuidSelectVariantAndVariantIdApiArg = {
  "variant-id": string;
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  variantSelectionOptions: VariantSelectionOptions;
};
export type PostConfigurationByUuidSelectVariantsApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostConfigurationByUuidSelectVariantsApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  multiVariantSelectionRequest: MultiVariantSelectionRequest;
};
export type PostConfigurationByUuidStepAndStepApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostConfigurationByUuidStepAndStepApiArg = {
  groupForCompatibilityCheck?: ProductGroupId;
  uuid: EcmConfigId;
  step: StepId;
  configurationStepDataOptions: ConfigurationStepDataOptions;
};
export type PutConfigurationByUuidSwitchBaseParametersApiResponse =
  /** status 200 OK */ SwitchBaseParametersResponse;
export type PutConfigurationByUuidSwitchBaseParametersApiArg = {
  uuid: EcmConfigId;
  switchBaseParametersRequest: SwitchBaseParametersRequest;
};
export type PostConfigurationByUuidUndocommitApiResponse =
  /** status 200 OK */ ConfigurationStepData;
export type PostConfigurationByUuidUndocommitApiArg = {
  uuid: EcmConfigId;
  configurationStepDataOptions: ConfigurationStepDataOptions;
};
export type PostConvertEcmConfigByUuidApiResponse =
  /** status 201 CREATED */ ManCodeResponse;
export type PostConvertEcmConfigByUuidApiArg = {
  uuid: EcmConfigId;
  ecmConversionTarget: EcmConversionTarget;
};
export type PostConvertMancodeApiResponse =
  /** status 201 CREATED */ ManCodeConversionResponse;
export type PostConvertMancodeApiArg = {
  manConversionTarget: ManConversionTarget;
};
export type PostConvertTg3CodeByLanguageApiResponse =
  /** status 200 OK */ Tg3ToMaicConversionResponse;
export type PostConvertTg3CodeByLanguageApiArg = {
  /** Indicates if empty component groups will be returned */
  addEmptyGroups?: boolean;
  /** Indicates if empty families will be returned */
  addEmptyFamilies?: boolean;
  /** Indicates if hidden codes that are excluded from the response */
  excludeHiddenCodes?: boolean;
  /** Indicates if codes that are ineffective for sales are excluded from the response */
  excludeIneffectiveCodes?: boolean;
  /** Indicates if mapping from V-codes to FPC-codes should be computed and returned */
  addFpcMapping?: boolean;
  /** Denotes the target language that will be used for textual configuration descriptions */
  language: LanguageIsoCode;
  /** Identifies the ECM view which the C4S assembly hierarchy is mapped to */
  viewId?: ViewId;
  tg3ConversionRequest: Tg3ConversionRequest;
};
export type GetProductdataGetconfigurationtypeidsApiResponse =
  /** status 200 OK */ ConfigTypeInfo;
export type GetProductdataGetconfigurationtypeidsApiArg = void;
export type GetProductdataGetvehicletypeidsApiResponse =
  /** status 200 OK */ VehicleTypeInfo;
export type GetProductdataGetvehicletypeidsApiArg = void;
export type GetProductdataGetviewheadersByMarketIdApiResponse =
  /** status 200 OK */ ViewHeaderInfo;
export type GetProductdataGetviewheadersByMarketIdApiArg = {
  marketId: MarketId;
};
export type GetProductdataImportantFamiliesFactoryApiResponse = unknown;
export type GetProductdataImportantFamiliesFactoryApiArg = void;
export type GetProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiResponse =
  /** status 200 OK */ AllFamiliesResponse;
export type GetProductdataMarketByMarketIdLanguageAndLanguageIdFamiliesApiArg =
  {
    languageId: LanguageId;
    marketId: MarketId;
    includeOnlyLocalCodes?: boolean;
    viewId?: ViewId;
  };
export type GetProductdataMarketByMarketIdLanguagesApiResponse =
  /** status 200 OK */ MarketLanguages;
export type GetProductdataMarketByMarketIdLanguagesApiArg = {
  marketId: MarketId;
};
export type GetProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiResponse =
  /** status 200 OK */ DddToPpResponse;
export type GetProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateApiArg =
  {
    vehicleTypeId: VehicleTypeId;
    marketId: MarketId;
    desiredDealerDate: DesiredDealerDate;
  };
export type GetTg3CodeByIdApiResponse =
  /** status 200 OK */ LegacyManCodeResponse;
export type GetTg3CodeByIdApiArg = {
  id: string;
};
export type GetUserdataGetmarketsApiResponse = /** status 200 OK */ MarketInfo;
export type GetUserdataGetmarketsApiArg = void;
export type GetUserdataLoadApiResponse = /** status 200 OK */ UserData;
export type GetUserdataLoadApiArg = void;
export type PostUserdataUpdateApiResponse = unknown;
export type PostUserdataUpdateApiArg = {
  userData: UserData;
};
export type GetTokenManagementApiResponse = unknown;
export type GetTokenManagementApiArg = void;
export type PostUnittestingApiResponse = /** status 200 OK */ Blob;
export type PostUnittestingApiArg = void;
export type AdminStatusResponse = {
  /** Textual description of outcome state */
  title: string;
  /** Integer indicating a certain outcome state */
  status: number;
};
export type LocalizedString = {
  [key: string]: string;
};
export type AdminNatCodesItemDescription = {
  /** A value hinting at the rank this object should take in an array of objects of the same type. */
  priorityForSorting?: number;
  description?: LocalizedString & object;
  label?: LocalizedString & object;
};
export type Period = string;
export type VehicleTypeId = number;
export type ViewId = number;
export type LanguageId = number;
export type LanguageIsoCode = string;
export type AdminToolMarketLanguage = {
  languageLabel: LocalizedString;
  languageId: LanguageId;
  languageCode: LanguageIsoCode;
};
export type ConfigTypeId = number;
export type CountryIsoCode = string;
export type Currency = string;
export type NatCodeCurrency = Currency;
export type MarketId = number;
export type AdminNatCodesMarketDescription = AdminNatCodesItemDescription & {
  validPartPeriodStart?: Period;
  vehicleTypeId?: VehicleTypeId;
  /** A list of tags hinting at the target audience for this market */
  plannedUsage?: string[];
  viewId?: ViewId;
  languages?: AdminToolMarketLanguage[];
  validPartPeriodEnd?: Period;
  configTypeId?: ConfigTypeId;
  countryCode?: CountryIsoCode & any;
  currency?: NatCodeCurrency;
  marketId?: MarketId;
};
export type AdminNatCodesGroupId = string;
export type AdminNatCodesGroupDescription = AdminNatCodesItemDescription & {
  /** Name of corresponding group in ECM vehicle schema */
  ecmReference?: string;
  groupId?: AdminNatCodesGroupId;
};
export type AdminNatCodesFamilyId = string;
export type AdminNatCodesFamilyDescription = AdminNatCodesItemDescription & {
  familyId?: AdminNatCodesFamilyId;
};
export type AdminNatCodesExecutionId = string;
export type AdminNatCodesBooleanRule = string;
export type NatCodeOrderRelevant = boolean;
export type CodeRelevantForResidualValue = boolean;
export type NatCodeCondition =
  | "C"
  | "E"
  | "G"
  | "I"
  | "K"
  | "L"
  | "N"
  | "O"
  | "S"
  | "U"
  | "V"
  | "W"
  | "Z";
export type CodeHideCode = boolean;
export type PictureIndex = number[];
export type CodeTopOption = boolean;
export type NatCodeCommissionRelevant = boolean;
export type CodeGrossListPrice = number;
export type NatCodeClassification = "A" | "T" | "S";
export type PrintingOptions = (
  | "picture"
  | "boldCode"
  | "extendedDescription"
  | "hidden"
)[];
export type CodePrintingOptions = PrintingOptions;
export type CodeWithoutCode = boolean;
export type CodeRelevantForMaintenanceAndRepairBenefits = boolean;
export type AdminNatCodesCodeBaseBaseDescription =
  AdminNatCodesItemDescription & {
    executionId?: AdminNatCodesExecutionId;
    /** Set of Boolean rules used to decide whether this code can be added to an existing vehicle configuration */
    rules?: AdminNatCodesBooleanRule[];
    attributes?: {
      orderRelevant?: NatCodeOrderRelevant;
      relevantForResidualValue?: CodeRelevantForResidualValue;
      condition?: NatCodeCondition;
      hideCode?: CodeHideCode;
      pictureIndex?: PictureIndex;
      topOption?: CodeTopOption;
      commissionRelevant?: NatCodeCommissionRelevant;
      grossListPrice?: CodeGrossListPrice;
      classification?: NatCodeClassification;
      printingOptions?: CodePrintingOptions;
      withoutCode?: CodeWithoutCode;
      relevantForMaintenanceAndRepairBenefits?: CodeRelevantForMaintenanceAndRepairBenefits;
    };
    validFrom?: Period & any;
    validTo?: Period & any;
  };
export type AdminNatCodesCodeId = string;
export type AdminNatCodesCodeBaseDescription =
  AdminNatCodesCodeBaseBaseDescription & {
    codeId?: AdminNatCodesCodeId;
  };
export type AdminNatCodesCodeStatus =
  | "draft"
  | "published"
  | "draft_formerly_published";
export type AdminNatCodesCodeDescription = AdminNatCodesCodeBaseDescription & {
  status?: AdminNatCodesCodeStatus;
};
export type AdminNatCodesCode = AdminNatCodesCodeDescription & object;
export type AdminNatCodesFamily = AdminNatCodesFamilyDescription & {
  codes?: AdminNatCodesCode[];
};
export type AdminNatCodesGroup = AdminNatCodesGroupDescription & {
  families?: AdminNatCodesFamily[];
};
export type AdminNatCodesMarket = AdminNatCodesMarketDescription & {
  groups?: AdminNatCodesGroup[];
};
export type AdminAllMarketsResponse = AdminStatusResponse & {
  /** List of all available markets in national codes admin tool */
  markets?: (AdminNatCodesMarketDescription | AdminNatCodesMarket)[];
};
export type AdminErrorResponse = AdminStatusResponse & {
  /** Information on the error that occurred */
  error: {
    /** Additional debug information */
    metadata?: {
      [key: string]: any;
    };
    /** Descriptive error message */
    description: string;
  };
};
export type AdminMarketDescriptionResponse = AdminStatusResponse & {
  market?: AdminNatCodesMarket;
};
export type AdminNatCodesNewMarketRequest = AdminNatCodesMarketDescription &
  object;
export type ZonedDateTime = string;
export type ProductFamilyId = string;
export type FlattenedFpcCode = string;
export type FactoryCodeItemId = ProductFamilyId | FlattenedFpcCode;
export type Attributes = {
  [key: string]: any;
};
export type FactoryCodeAttributes = {
  createdAt: ZonedDateTime;
  code: FactoryCodeItemId;
  attributes: Attributes;
  updatedAt: ZonedDateTime;
};
export type AdminAllFactoryCodeAttributesResponse = AdminStatusResponse & {
  listOfFactoryCodeAttributes?: FactoryCodeAttributes[];
};
export type AdminFactoryCodeAttributesResponse = AdminStatusResponse & {
  factoryCodeAttributes?: FactoryCodeAttributes;
};
export type FactoryCodeAttributeRequest = {
  attributes?: Attributes;
};
export type AdminNatCodesGroupDescriptionResponse = AdminStatusResponse & {
  group?: AdminNatCodesGroup;
};
export type AdminNatCodesNewGroupRequest = AdminNatCodesGroupDescription & {
  groupId: AdminNatCodesGroupId;
};
export type AdminNatCodesFamilyDescriptionResponse = AdminStatusResponse & {
  family?: AdminNatCodesFamily;
};
export type AdminNatCodesNewFamilyRequest = AdminNatCodesFamilyDescription & {
  familyId: AdminNatCodesFamilyId;
};
export type AdminNatCodesCodeDescriptionResponse = AdminStatusResponse & {
  code?: AdminNatCodesCode;
};
export type AdminNatCodesNewCodeRequest =
  AdminNatCodesCodeBaseBaseDescription & {
    executionId: AdminNatCodesExecutionId;
  };
export type ImportantFamilies = ProductFamilyId[];
export type ImportantFamiliesCountryResponse = AdminStatusResponse & {
  importantFamilies: ImportantFamilies;
};
export type ImportantFamiliesCountryRequest = {
  importantFamilies: ImportantFamilies;
};
export type SelectionType = "User" | "Default" | "Explicit" | "Implicit";
export type ProductVariantId = string;
export type FpcCommonCode = {
  relevantForResidualValue?: CodeRelevantForResidualValue;
  /** Concatenates family and execution */
  code?: string;
  pictureIndex?: PictureIndex;
  topOption?: CodeTopOption;
  /** Textual description of the variant's family */
  familyDescription?: string;
  relevantForMaintenanceAndRepairBenefits?: CodeRelevantForMaintenanceAndRepairBenefits;
  selectionType?: SelectionType;
  hideCode?: CodeHideCode;
  /** Textual description of the variant */
  variantDescription?: string;
  variant: ProductVariantId;
  grossListPrice?: CodeGrossListPrice;
  family: ProductFamilyId;
  printingOptions?: CodePrintingOptions;
  withoutCode?: CodeWithoutCode;
};
export type SpecificationType = "O" | "C" | "V";
export type FpcFactoryCode = FpcCommonCode & {
  /** The code's specification type(s). Source: ECM */
  specTypes?: SpecificationType[];
  /** Controls the display of FPC codes in the frontend. If the attribute is set to true, the FPC Code will not be displayed in the FE. Source: Product Data from XDMA. */
  ineffectiveForSales?: boolean;
  /** Controls the display of prices in the frontend. If the attribute is set to true, the grossListPrice of the FPC code will not be displayed in the FE. Source: Product Data from XDMA. */
  noDisplayOfAbsolutePrice?: boolean;
};
export type ManCodeId = string;
export type ReferenceTuckId = string;
export type MarketDenomination = string;
export type ReferenceTruck = {
  cabType?: FpcFactoryCode;
  MANCodeId: ManCodeId;
  customText?: LocalizedString;
  weight?: string;
  axleDistance?: FpcFactoryCode;
  createdAt: ZonedDateTime;
  application?: FpcFactoryCode;
  referenceTruckId: ReferenceTuckId;
  previewImageURL?: string;
  usages?: FpcFactoryCode;
  marketDenomination?: MarketDenomination;
  operation?: FpcFactoryCode;
  updatedAt: ZonedDateTime;
};
export type AdminAllReferenceTrucksResponse = AdminStatusResponse & {
  listOfReferenceTrucks?: ReferenceTruck[];
};
export type AdminReferenceTrucksResponse = AdminStatusResponse & {
  referenceTruck?: ReferenceTruck;
};
export type PublicationStatus = "draft" | "published" | "archived";
export type UpdateReferenceTruckRequest = {
  publicationStatus?: PublicationStatus;
  MANCodeId?: ManCodeId;
  customText?: LocalizedString & any;
  customTitle?: LocalizedString & any;
};
export type NewReferenceTruckRequest = UpdateReferenceTruckRequest & {
  publicationStatus?: PublicationStatus & any;
};
export type ResponseEnvelopeMessage = {
  messageType?: string;
  content?: string;
};
export type ResponseEnvelope = {
  hasErrors?: boolean;
  success?: boolean;
  messages?: ResponseEnvelopeMessage[];
  /** Specific Response containing either vehicle-dimensions, dp, dvs or n3g information. */
  content?: object;
};
export type DvsResponse = ResponseEnvelope & {
  content?: {
    remainingHeightToNextStarRating?: string;
    starRating?: string;
  };
};
export type DpResponse = ResponseEnvelope & {
  content?: {
    AggregatedOutput?: object;
    OptionalResults?: object[];
    MissionResult?: object;
  };
};
export type CavaResponse = {
  content?: {
    /** Contains Direct Vision Standard information - can currently be anything */
    dvs?: DvsResponse;
    /** Contains information specific to the N3G vehicle category - can currently be anything */
    n3g?: any;
    /** Contains information about vehicle dimensions - can currently be anything */
    vehicleDimensions?: any;
    /** Contains basic information about axles, suspension, etc. - can currently be anything */
    productData?: any;
    /** Contains DP information - can currently be anything */
    dp?: DpResponse;
  };
};
export type ErrorResponse = {
  error?: {
    /** Further details about the error */
    metadata?: {
      [key: string]: any;
    };
    /** Descriptive error message */
    description?: string;
    /** Textual description of outcome state */
    title?: string;
    /** Technical error type / code */
    type?: string;
    /** Integer indicating a certain outcome state */
    status?: number;
  };
};
export type StatusResponse = {
  /** Further details about the error */
  metadata?: {
    [key: string]: any;
  };
  /** Descriptive error message */
  description?: string;
  /** Textual description of outcome state */
  title?: string;
  /** Technical error type / code */
  type?: string;
  /** Integer indicating a certain outcome state */
  status?: number;
};
export type CavaTransportMission = object;
export type CavaRequest = {
  /** Indicates whether to include DP information. This will provide information with respect to some transport mission */
  includeDp?: boolean;
  /** Specifies details about the transport mission which is needed if includeDp is set to True */
  transportMission?: {
    data?: CavaTransportMission;
    /** Indicates whether to use hard-coded mock data as a transport mission or rather to use the one provided in the data field */
    useMockData?: boolean;
  };
  /** Indicates whether to include information specific to the N3G vehicle category */
  includeN3g?: boolean;
  /** Indicates whether to include Direct Vision Standard information */
  includeDvs?: boolean;
  /** Indicates whether to include information about vehicle dimensions in the response */
  includeDimensions?: boolean;
};
export type VariantList = {
  familyId: ProductFamilyId;
  variantId: ProductVariantId;
}[];
export type CavaProvisionedRequest = CavaRequest & {
  variants: VariantList;
};
export type EcmConfigId = string;
export type UpdatePatchLocation = string;
export type UpdatePatchPath = UpdatePatchLocation & string;
export type UpdatePatchValue = FpcFactoryCode & object;
export type UpdatePatchAdd = {
  op?: string;
  path?: UpdatePatchPath;
  value?: UpdatePatchValue & any;
};
export type UpdatePatchFrom = UpdatePatchLocation & string;
export type UpdatePatchCopy = {
  op?: string;
  path?: UpdatePatchPath;
  from?: UpdatePatchFrom;
};
export type UpdatePatchMove = {
  op?: string;
  path?: UpdatePatchPath;
  from?: UpdatePatchFrom;
};
export type UpdatePatchRemove = {
  op?: string;
  path?: UpdatePatchPath;
};
export type UpdatePatchReplace = {
  op?: string;
  path?: UpdatePatchPath;
  value?: UpdatePatchValue & any;
};
export type UpdatePatchTest = {
  op?: string;
  path?: UpdatePatchPath;
  value?: UpdatePatchValue & any;
};
export type UpdatePatch =
  | UpdatePatchAdd
  | UpdatePatchCopy
  | UpdatePatchMove
  | UpdatePatchRemove
  | UpdatePatchReplace
  | UpdatePatchTest;
export type ManCodeJournalEntry = {
  /** Indicates the place that this update takes in a series of updates */
  entryNumber?: number;
  /** Indicates which calling system performed the update */
  updatingSystem?: string;
  /** Indicates which calling user performed the update */
  updatingUser?: string;
  /** Describes the update operations that were conducted to arrive at this version of the MANCode */
  forwardUpdateOperations?: UpdatePatch[];
  /** Describes the update operations that would need to be conducted to arrive at a the previous version of this MANCode */
  backwardUpdateOperations?: UpdatePatch[];
  updateTimestamp?: ZonedDateTime & string;
};
export type ManCodeJournal = {
  /** Individual updates of a MANCode */
  entries?: ManCodeJournalEntry[];
  /** Indicates which patch of the journal is currently active */
  currentPatch?: number;
};
export type DesiredDealerDate = string;
export type OrderCountry = CountryIsoCode;
export type VehicleDescription = string;
export type FpcNationalCode = FpcCommonCode & {
  orderRelevant?: NatCodeOrderRelevant;
  condition?: NatCodeCondition;
  /** Concatenates family and execution */
  code?: string;
  commissionRelevant?: NatCodeCommissionRelevant;
  /** Textual description of the national code */
  name?: string;
  currency?: NatCodeCurrency;
  /** The variant's family */
  family?: string;
  classification?: NatCodeClassification;
};
export type EcmParameters = {
  vehicleTypeId: VehicleTypeId;
  viewId: ViewId;
  configurationTypeId: ConfigTypeId;
  languageId?: LanguageId;
  marketId: MarketId;
};
export type SpecialRequest = boolean;
export type KeyValuePair = {
  value?: string;
  key?: string;
};
export type KeyValuePairList = KeyValuePair[];
export type MaicInternal = {
  keyValuePairs?: KeyValuePairList;
};
export type VehicleConfiguration = {
  /** Represents an ID for verifying a new central data status after the publication of this data in EBO. Source: tba. */
  centralDataVersion?: number;
  /** A list of all selected FPC codes from the factory set. Source: ECM */
  factoryFPCCodes?: FpcFactoryCode[];
  partPeriod?: Period;
  validationPartPeriod?: Period;
  orderLanguage?: LanguageIsoCode;
  /** Represents the requested delivery date, which was passed on as a call parameter by the source systems. This value might represent an estimate. Source: MAIC Frontend (if set by user) or Backend (). */
  desiredDealerDate?: DesiredDealerDate;
  orderCountry?: OrderCountry;
  /** Indicates if the desired dealer date was estimated from a part period or refers to a concrete date that was set by the user. Source: MAIC Backend */
  desiredDealerDateIsEstimate?: boolean;
  vehicleDescription?: VehicleDescription;
  /** A list of all selected FPC from the national or business unit set. Source: MAIC Admintool */
  nationalFPCCodes?: FpcNationalCode[];
  ecmParameters?: EcmParameters;
  /** Represents an ID for verifying a new national data status after the publication of this data in EBO. Source: MAIC Admintool. */
  nationalDataVersion?: number;
  specialRequest?: SpecialRequest;
  /** Represents the sum of all individual priced FPC codes and thus the gross list price of the vehicle. Source: MAIC Frontend/Backend. */
  grossListPrice?: number;
  /** Represents the status of the configuration or quotation or purchase order, depending on the process step in which the configuration is located. Source: ITOS */
  overallStatus?: "quote" | "order" | "orderChange" | "processedLUR";
  MAICInternal?: MaicInternal;
};
export type QueryParameterSystem = string;
export type SystemToken = {
  system?: QueryParameterSystem;
};
export type SystemTokens = SystemToken[];
export type ManCodeObjectVersion = string;
export type ManCode = {
  code?: ManCodeId;
  journal?: ManCodeJournal;
  configuration?: VehicleConfiguration;
  /** ID of the user that created this MANCode. Note that in responses, this information will only be displayed for consumers with appropriate access rights */
  createdByUser?: string;
  /** ID of the system that created this MANCode. Note that in responses, this information will only be displayed for consumers with appropriate access rights */
  createdBySystem?: string;
  insertTimestamp?: ZonedDateTime;
  tokens?: SystemTokens;
  manCodeObjectVersion?: ManCodeObjectVersion;
  manCodeReference?: ManCodeId;
  updateTimestamp?: ZonedDateTime;
};
export type ManCodeResponse = {
  code: ManCode;
};
export type CodeCreatedResponse = {
  feedback?: ManCodeResponse | ErrorResponse;
};
export type ManCodeRequest = {
  /** Indicates whether header data should also be copied */
  directCopy?: boolean;
  MANCode: ManCode;
};
export type CheckCodeResponse = {
  /** Textual description of outcome details, e.g. an explanation why a code is no longer valid */
  outcomeDetails?: string;
  /** Indicates if the MANCode is valid or not */
  outcome?: "valid" | "invalid";
};
export type SystemListResponse = {
  /** List of systems for which tokens are set */
  systems?: string[];
};
export type TokenRequest = {
  /** List of systems for which tokens are to be set */
  systems?: string[];
};
export type Configuration = {
  title: MarketDenomination;
  uuid: EcmConfigId;
};
export type VariantSelectionType = "Default" | "Explicit" | "Implicit";
export type VariantIsSelected = boolean;
export type EcmConfigurationTarget = {
  /** Specifies the target vehicle type. Though you should use the correct one, it somehow does not seem to matter too much which ID is used as long as it is not too large. 11 seems to always work nicely... */
  vehicleTypeID: VehicleTypeId;
  /** Specifies the target view */
  viewID: ViewId;
  /** Specifies the target configuration type. If the there are no configuration types associated with your target market, do not include this property in the request body. However, if there are configuration type ids available for the market, you must select one, otherwise the request will fail */
  configurationTypeID?: ConfigTypeId;
  /** List of variants with which to start the configuration */
  startingVariants?: {
    familyId?: ProductFamilyId;
    selectionType?: VariantSelectionType;
    isSelected?: VariantIsSelected;
    variantId?: ProductVariantId;
  }[];
  /** Specifies the target ?construction? period. Use either this or desiredDealerDate. If both are used, confiremdPartPeriod is ignored. */
  confirmedPartPeriod?: Period;
  /** Specifies the target ?construction? day. Use either this or confirmedPartPeriod. If both are used, confiremdPartPeriod is ignored. */
  desiredDealerDate?: DesiredDealerDate;
  languageID?: LanguageId;
  /** Specifies the target market */
  marketID: MarketId;
};
export type ProductFamilyTitle = string;
export type ProductVariant = {
  selectionType?: VariantSelectionType;
  /** Automatically generated dummy price, not to be confused with actual real-world prices. It is deterministic and depends on the variant's family's id and on the variant's id. Note that currently each variant is assigned a dummy price although that does not make sense for e.g. some of the variants used in the General Step. */
  dummy_price?: number;
  isSelected?: VariantIsSelected;
  hasDetailData?: boolean;
  id: ProductVariantId;
  /** Textual description of the variant, depends on selected language */
  title: string;
  /** Hints at the compatibility of this variant with the current vehicle. 'incompatible' means that the selection would result in a conflict with at least one of the user-selected variant. 'unknown' means that no definite statement about the variant's compatibility can be made. 'invalid' is a relic stemming from an earlier ECM iteration and should be treated the same as 'compatibilityUnknown', however, it should hopefully never occur */
  compatibility?: "unknown" | "incompatible" | "invalid";
};
export type ProductGroupId = string;
export type ProductFamily = {
  hasDetailData?: boolean;
  id: ProductFamilyId;
  variants: ProductVariant[];
  totalVariantCount: number;
  title: ProductFamilyTitle;
  selectedVariantIndex?: number;
};
export type ProductGroup = {
  subGroups?: ProductGroup[];
  id: ProductGroupId;
  title: string;
  families?: ProductFamily[];
};
export type VariantConsequences = {
  /** Information about the family of the variant that was changed */
  productFamily?: {
    id?: ProductFamilyId;
    title?: ProductFamilyTitle;
  };
  /** Variant in the previous configuration. Note that this property is only contained if the old variant was replaced or removed, but not if an entirely new variant was added. */
  previousVariant?: ProductVariant;
  /** The new variant. Note that this property is only contained if the previous variant was replaced or if a completely new variant was added, but not if the old variant was removed. */
  currentVariant?: ProductVariant;
  /** Indicates whether the old variant was changed, removed, or a new variant was added */
  variantStatus?: "Added" | "Changed" | "Removed";
}[];
export type ConsequencesOfChange = {
  /** Added, changed, or removed variants that were part of the previous configuration   and were selected explicitely by the user */
  variantConflictingChoices?: VariantConsequences;
  /** Added, changed, or removed variants that were part of the previous configuration   but that were not selected explicitely by the user. */
  variantConsequences?: VariantConsequences;
};
export type ConfigurationStepData = {
  currentStep?: string;
  /** Describes which variants do not fit the producers technical recommendations properly */
  outOfRecommendationWarnings?: {
    familyId?: ProductFamilyId;
    /** Further textual explanation of the warning */
    notes?: string;
    /** Classification of the warning's type */
    outOfRecommendationHint?: "OutOfRecommendation" | "Hint";
    variantId?: ProductVariantId;
  }[];
  /** Contains information about required changes to the configuration to make the vehicle buildable again. This field should only contain information if apply_suggested_changes was set to False. */
  suggestions?: {
    /** Describes required changes in the current vehicle configuration in terms of variant modifications. This property will presumably only be set if the response corresponds to a change variant request in which conflicting changes are not to be applied immediately. */
    requiredChanges?: {
      /** Information about the family of the variant that needs to be changed */
      productFamily?: {
        id?: ProductFamilyId;
        title?: ProductFamilyTitle;
      };
      /** The variant that is to replace the current variant. */
      replacementVariant?: ProductVariant;
      /** Variant in the current configuration that is up for replacement. */
      currentVariant?: ProductVariant;
    }[];
    /** Lists pinned variants that would be violated if the user-selected variants would have been applied */
    violatedPins?: VariantList;
    /** Lists variants that were set by the consuming system to the indicated values but which could not be set these values due to conflicts. This property will presumably only be set if the response corresponds to a change variant request in which conflicting changes are not to be applied immediately. */
    failedCommits?: VariantList;
  };
  marketDenomination?: MarketDenomination;
  productGroups: ProductGroup[];
  /** Describes consequences resulting from one ore more changed variants. Note that if you are dealing with the result of an undo-operation, this property will contain the result from before the reverted variant selection. */
  consequencesOfChange?: ConsequencesOfChange;
  /** Technical data points of the current configuration. Note that unfortunately the ECM documentation does not provide any explanations for the particular properties, our descriptions are therefore more or less guesswork */
  measurements?: {
    /** Denotes the unit in which the acutal measure was taken. Note that this property seems to be missing often */
    unit?: string;
    /** The measurement's ID */
    name?: string;
    /** Textual description of the measurement */
    description?: string;
    /** Not clear */
    source?: "OAS" | "Configurator";
    value?: string;
  }[];
};
export type CorrelationId = string;
export type EcmSignalStatus = "Green" | "Yellow" | "Red";
export type BaseCheckResponse = {
  /** Probably indicates if there was some problem when connecting to the service that conducts the check */
  isConnectionError?: boolean;
  correlationId?: CorrelationId;
  /** Indicates if the requested check was disabled for this configuration. If true, no check result will be returned */
  disabled?: boolean;
  status?: EcmSignalStatus;
};
export type BrakeCheckResponse = BaseCheckResponse & {
  messages?: any;
  /** Detailed description of the brake check. Note that this field will be missing if brake checking for this configuration was disabled which can be done in the SECM Admin Tool */
  content?: {
    brakeRatioDemandFulfilled?: boolean;
    weight?: {
      unladen?: number;
      legalMinimum?: number;
    };
    unladenWeightDemandFulfilled?: boolean;
    axle?: {
      usedRearAxleIndexes?: number[];
    };
    brakeRatio?: {
      legalMinimum?: number;
      value?: number;
    };
  };
};
export type CheckErrorResponse = {
  correlationId?: CorrelationId;
  error?: string;
};
export type InternalServerError = {
  error?: {
    /** Error code */
    code?: string;
    /** Coarse textual error description */
    description?: string;
    /** More detailled textual description of the error */
    details?: string;
  };
};
export type DvsCheckResponse = BaseCheckResponse & {
  hasErrors?: boolean;
  messages?: any;
  /** Detailed description of the Direct Vision Standard test. Note that this field will be missing if brake checking for this configuration was disabled which can be done in the SECM Admin Tool */
  content?: {
    remainingHeightToNextRating?: string;
    starRating?: number;
  };
};
export type OasMessages = {
  description?: string;
  comment?: string;
  id?: number;
  text?: string;
  categoryID?: number;
}[];
export type OasCheckResponse = BaseCheckResponse & {
  oasResult?: {
    warnings?: OasMessages;
    messages?: OasMessages;
    errors?: OasMessages;
    informations?: OasMessages;
  };
  partPeriod?: Period;
};
export type OasCheckType = "extended" | "tcr_vcr";
export type TireCheckResponse = BaseCheckResponse & {
  hasErrors?: boolean;
  messages?: any;
  /** Represents the content details of a tyre check result */
  content?: {
    /** ECM publish date */
    ecmPublishDate?: string;
    tyreDetails?: {
      variant?: ProductVariantId;
      /** Textual description of the tire */
      description?: string;
      /** Specifies the tire's/tires' position(s) in the vehicle */
      tyrePosition?: string;
      family?: ProductFamilyId;
      /** The tyirs content statuses: UNDEFINED - The tyre content was not defined OK - The tire content is OK. FAILED - The tire content has failed. NOT_FOUND - The tire content was not found */
      status?: "UNDEFINED" | "OK" | "FAILED" | "NOT_FOUND";
    }[];
    /** Contains an FPC code representing a country */
    countryDetails?: {
      variant?: ProductVariantId;
      /** Textual description of the country code */
      description?: string;
      family?: ProductFamilyId;
    };
    /** Some ECM revision number */
    revision?: string;
  };
};
export type WeightCheckResponse = BaseCheckResponse & {
  hasErrors?: boolean;
  messages?: {
    referenceIndex?: string;
    messageType?: string;
    content?: string;
  }[];
  /** Detailed description of the weight check. Note that this field will be missing if brake checking for this configuration was disabled which can be done in the SECM Admin Tool */
  content?: {
    totalWeight?: number;
    frontAxleWeight?: number;
    rearAxleWeight?: number;
  };
};
export type ConfigurationStepDataOptions = {
  /** Indicates whether the current vehicle configuration should be returned */
  returnCurrentConfiguration?: boolean;
};
export type VariantSelectionOptions = ConfigurationStepDataOptions & {
  /** Indicates if the selected variant is in conflict with previously selected variants, the solution proposed by the solver to overcome this conflict should be directly applied or if the consuming system should only be informed about suggested changes without applying them. Note however that in the latter case the returned suggestions will deviate from what will actually be changed. */
  apply_suggested_changes?: boolean;
  /** Indicates if the provided variants are to be added to the vehicle configuration one after the other or if they should be added all at once. The choice of this flag might have a severe impact. If two variants are given that cannot be part of the same configuration, consecutive application in conjunction with apply_suggested_changes=True will first add one variant to the vehicle. This variant will then be removed again before the second variant is added. All-at-once application on the other hand will fail and return an error message indicating the conflicting variants. If apply_suggested_changes=False the result for consecutive and all-at-once application will be similar and no changes will occur. If the given variants are however compatible with each other, both application schemes should yield similar results. Note: If option pinning is used, select_variants_consecutively must be set to False, as there is currently no other way to make pinning work. Also not that if select_variants_consecutively is set to True, the order of the variants designated for selection might influence the final result. */
  select_variants_consecutively?: boolean;
};
export type MultiVariantDeselectionRequest = VariantSelectionOptions & {
  /** List of variants that are to be deselected. */
  variantsForDeselection?: VariantList;
};
export type UnifiedStatusResponse = {
  /** Textual description of outcome state */
  title: string;
  /** Integer indicating a certain outcome state */
  status: number;
};
export type RefreshConfigurationResponse = UnifiedStatusResponse & {
  /** Indicates if the refresh was successful */
  refreshed?: boolean;
  uuid?: EcmConfigId & string;
};
export type UnifiedErrorResponse = UnifiedStatusResponse & {
  /** Information on the error that occurred */
  error: {
    /** Additional debug information */
    metadata?: {
      [key: string]: any;
    };
    /** Descriptive error message */
    description: string;
  };
};
export type MultiVariantSelectionRequest = VariantSelectionOptions & {
  /** List of variants in the current configuration that must not be changed */
  pinnedVariants?: VariantList;
  /** List of variants that are to be selected. Note that if select_variants_consecutively=True is used, the order of the variants might have an impact in the selection result, especially of one or more of variants are incompatible with each other. */
  variantsForSelection?: VariantList;
};
export type StepId = number;
export type ChangedVariantList = {
  familyId?: ProductFamilyId;
  newVariantId?: ProductVariantId;
  oldVariantId?: ProductVariantId;
}[];
export type EcmConfiguratorStatus =
  | "ConfiguratorChangesNeeded"
  | "ConfiguratorCommitsFailed"
  | "ConfiguratorError"
  | "ConfiguratorException"
  | "ConfiguratorStepchangeFailed"
  | "ConfiguratorTimeout"
  | "Ok"
  | "OkPartial"
  | "OperationNotAllowed"
  | "UnspecifiedApplicationError";
export type SwitchBaseParametersResponse = UnifiedStatusResponse & {
  newVariants?: VariantList & any;
  changedVariants?: ChangedVariantList & any;
  newUuid?: EcmConfigId & string;
  removedVariants?: VariantList & any;
  newConfigStatus?: EcmConfiguratorStatus & string;
};
export type SwitchBaseParametersRequest = {
  /** ECM base parameters of the new configuration. Apart from the required properties, make sure to include either confirmedPartPeriod or desiredDealerDate */
  ecmParameters?: {
    vehicleTypeID: VehicleTypeId;
    viewID: ViewId;
    configurationTypeID: ConfigTypeId;
    confirmedPartPeriod?: Period;
    desiredDealerDate?: DesiredDealerDate;
    languageID: LanguageId;
    marketID: MarketId;
  };
};
export type EcmConversionTarget = {
  additionalInformation: {
    /** ECM base parameters of the configuration that is to be converted */
    ecmParameters: {
      vehicleTypeId: VehicleTypeId;
      viewId: ViewId;
      configurationTypeId?: ConfigTypeId;
      languageId: LanguageId;
      marketId: MarketId;
    };
  };
  /** Indicates whether to include FPC code attribute in the resulting MAN Code */
  includeAttributes?: boolean;
  targetFormat: "MAN_CODE";
};
export type ManCodeEcmConversionResponse = {
  ecmConfigId?: EcmConfigId;
};
export type CavaInput = {
  VehicleData?: {
    Provision?: {
      PartPeriod?: Period;
      Fpc?: FlattenedFpcCode[];
    };
  };
};
export type ManCodeCavaInputConversionResponse = {
  cavaInput?: CavaInput;
};
export type ManCodeOasvSpecInputConversionResponse = {
  /** XML blob containing request body for an OAS request */
  oasVSpecInput?: string;
};
export type ManCodeConversionResponse = {
  conversionResult?:
    | ManCodeEcmConversionResponse
    | ManCodeCavaInputConversionResponse
    | ManCodeOasvSpecInputConversionResponse;
};
export type TargetFormat = "ECM";
export type EcmSpecificConversionParameters = {
  ecmParametersOverwrites?: {
    vehicleTypeId?: VehicleTypeId;
    viewId?: ViewId;
    configurationTypeId?: ConfigTypeId;
    languageId?: LanguageId;
    targetFormat?: TargetFormat;
    marketId?: MarketId;
  };
  partPeriodOverwrite?: Period;
};
export type OasSpecificConversionParameters =
  EcmSpecificConversionParameters & {
    /** Denotes the vehicle's root code */
    startObject?: string;
    /** Unknown parameter */
    validationModes?: "COMPLETE";
    targetFormat?: TargetFormat;
    /** Attribute defining validity of the ECO timestamps. Possible values are: 1. preliminary - time is defined by the CP responsible, and is used to analyze the product structure during development. 2. definitive - time is defined by the time setters (Info from SCANIA) */
    coTimeValidity?: "definitive" | "preliminary";
  };
export type CavaSpecificConversionParameters =
  EcmSpecificConversionParameters & {
    targetFormat?: TargetFormat;
  };
export type ManConversionTarget = {
  targetFormat: TargetFormat;
  manCode: ManCode;
  formatSpecificParameters?:
    | EcmSpecificConversionParameters
    | OasSpecificConversionParameters
    | CavaSpecificConversionParameters;
};
export type ExtraEquipment = {
  /** Unique extra equipment item identifier */
  code: string;
  /** Gross price of the extra equipment item */
  grossPrice?: number;
  /** Textual description of the extra equipment item */
  message?: string;
  /** Type of the equipment */
  type?: "customerSpecialRequest" | "manIndividualTruck" | "";
  printingOptions?: PrintingOptions;
};
export type TitledExtraEquipment = ExtraEquipment & {
  /** Textual extra equipment code description as derived from Data4MAN. Note that this description might vary from the one contained in the property 'message'. */
  title?: string;
};
export type BaseLegacyOption = {
  hideCode?: CodeHideCode;
  pictureIndex?: PictureIndex;
  topOption?: CodeTopOption;
  grossListPrice?: CodeGrossListPrice;
  printingOptions?: PrintingOptions;
  withoutCode?: CodeWithoutCode;
};
export type FactoryVCode = BaseLegacyOption & {
  /** Option ID */
  code?: string;
  driveTrainRecommendation?: boolean;
  /** If true, this option is not shown in the configurator (wrong spelling is due to compatibility reasons) */
  ineffectivForSales?: boolean;
  /** (Wrong spelling is due to compatibility reasons) */
  noDisplayOfAbsolutPrice?: boolean;
};
export type LegacyProductFactoryVariant = FactoryVCode & {
  /** Language-specific variant description */
  title?: string;
};
export type LegacyNationalProductGroup = {
  nationalCodes?: LegacyProductFactoryVariant[];
  /** Language-specific description of national product group */
  title?: string;
};
export type PaintInformation = {
  /** Identifies the colour */
  colour?: string;
  /** Identifies of the paint zone */
  paintZone?: string;
  /** Identifies the paint quality */
  quality?: string;
};
export type TitledPaintInformation = PaintInformation & {
  /** Textual paint code description as derived from Data4MAN. */
  title?: string;
};
export type RucksackOption = {
  /** TG3 option ID */
  code?: string;
  grossListPrice?: CodeGrossListPrice;
};
export type TitledRucksackOption = RucksackOption & {
  /** Textual rucksack code description as derived from Data4MAN */
  title?: string;
};
export type LegacyProductBaseFamily = {
  hasDetailData?: boolean;
  /** Family ID ('Gattung') */
  id: string;
  /** Number of variants in this family */
  totalVariantCount: number;
  /** Language specific family description */
  title: string;
  /** Index of selected variant in this family */
  selectedVariantIndex?: number;
};
export type LegacyProductFactoryFamily = LegacyProductBaseFamily & {
  variants?: LegacyProductFactoryVariant[];
};
export type LegacyProductSubgroup = {
  id: string;
  /** Language specific subgroup description */
  title: string;
  families?: LegacyProductFactoryFamily[];
};
export type LegacyProductGroup = {
  subGroups?: LegacyProductSubgroup[];
  id: string;
  /** Language specific group description */
  title: string;
  /** Reference to corresponding group in ECM view */
  ecm?: {
    /** Indicates how confident one should be in the established correspondence to the ECM group (0.0 no confidence - 1.0 full confidence) */
    confidence?: number;
    /** ID of ECM group that most closely corresponds to this legacy C4S group */
    groupReference?: string;
  };
};
export type AddOnCode = {
  /** Unique add-on identifier */
  code?: string;
  /** The add-on's gross price */
  grossPrice?: number;
  /** Textual description of the add-on */
  text?: string;
  /** Identifies the add-on's family */
  category?: string;
  /** Identifies the link to the add-on's family */
  categoryLink?: string;
  /** Textual description of the add-on's family */
  categoryText?: string;
};
export type TitledAddOnCode = AddOnCode & {
  /** Textual add-on code description as derived from Data4MAN. Note that this description might vary from the one contained in the property 'text' */
  title?: string;
};
export type LegacyManCodeId = string;
export type CodeTransformationResult = {
  /** Mapping from V-codes involved in this match to their respective shell. The lower the shell value, the more important the code is for the overall vehicle configuration */
  transformationTiers?: {
    [key: string]: string;
  };
  /** Value between 0.0 and 1.0 indicating the quality of the match */
  confidence?: number;
  /** Set of FPC-codes to which a set of V-codes was mapped. */
  fpcCodes?: FlattenedFpcCode[];
  /** Mapping from V-codes to FPC families. If the array containing FPC codes is empty but this mapping has content, then no automated mapping could be established, but a manual mapping to variants from the listed FPC families should be conducted be the user. Note that this map makes no sense for n:m mappings. We are in contact with the developers to get this straight, it will probably change at some point in the future. */
  fpcFamilies?: {
    [key: string]: string;
  };
  /** Mapping from V-codes to lock status as given in the input TG3 MANCode. This information is more or less useless, as it just returns the input. Might remove this later. */
  locks?: {
    [key: string]: "LOCKED" | "USER_LOCK" | "CLOSED";
  };
  /** Set of V-codes that are mapped to a set of FPC-codes */
  tg3VCodes?: string[];
  infos?: string[];
};
export type LegacyConversionServiceResponse = {
  metadata?: {
    [key: string]: string;
  };
  code?: LegacyManCodeId;
  codeTransformationResults?: CodeTransformationResult[];
  /** Textual description of errors that occured during conversion */
  errors?: string[];
};
export type Tg3ToMaicConversionResponse = {
  extraEquipments?: TitledExtraEquipment[];
  nationalProductGroups?: LegacyNationalProductGroup[];
  /** Textual description of problems that occurred during conversion */
  warnings?: string[];
  paintInformation?: TitledPaintInformation;
  rucksack?: TitledRucksackOption[];
  marketDenomination?: MarketDenomination;
  productGroups?: LegacyProductGroup[];
  addOnCodes?: TitledAddOnCode[];
  vCodesToFPCCodes?: LegacyConversionServiceResponse;
};
export type NationalVCode = BaseLegacyOption & {
  orderRelevant?: NatCodeOrderRelevant;
  condition?: NatCodeCondition;
  /** Option ID */
  code?: string;
  commissionRelevant?: NatCodeCommissionRelevant;
  currency?: NatCodeCurrency;
  classification?: NatCodeClassification;
  /** Not clear what this is */
  noCode?: boolean;
};
export type TechnicalData = {
  keyValuePairs?: KeyValuePairList;
};
export type LegacyVehicleConfiguration = {
  vehicleDescription?: VehicleDescription;
  /** List of extra equipment items */
  extraEquipments?: ExtraEquipment[];
  /** List of TG3 national codes */
  nationalVCodes?: NationalVCode[];
  technicalData?: TechnicalData;
  /** Describes which paints to apply to different parts of the vehicle */
  paintInformation?: PaintInformation[];
  /** List of options that need to be added back to the vehicle in order to make it buildable again */
  rucksack?: RucksackOption[];
  specialRequest?: SpecialRequest;
  /** List of codes that are added by AVIS / VMS due to KSW / MSW */
  addOnCodes?: AddOnCode[];
  orderCountry?: OrderCountry;
  /** List of TG3 factory codes */
  factoryVCodes?: FactoryVCode[];
};
export type LegacyManCode = {
  code?: LegacyManCodeId;
  configuration?: LegacyVehicleConfiguration;
  insertTimestamp?: ZonedDateTime;
  tokens?: SystemTokens;
  manCodeObjectVersion?: ManCodeObjectVersion;
  updateTimestamp?: ZonedDateTime;
};
export type Tg3ConversionRequest = {
  tg3Code: LegacyManCode;
  targetFormat?: "MAIC";
};
export type ConfigType = {
  configTypeID?: ConfigTypeId;
  /** Textual configuration type description */
  configTypeName?: string;
};
export type ConfigTypeInfo = {
  /** List of information on available ECM configuration types */
  listOfConfigTypes?: ConfigType[];
};
export type VehicleType = {
  vehicleTypeID?: VehicleTypeId;
  /** Textual vehicle type description */
  vehicleTypeName?: string;
};
export type VehicleTypeInfo = {
  /** List of information on available ECM vehicle types */
  listOfVehicleTypes?: VehicleType[];
};
export type ViewHeader = {
  viewID?: ViewId;
  /** Textual description of view header */
  viewName?: string;
};
export type ViewHeaderInfo = {
  /** List of information on view headers */
  listOfViewHeader?: ViewHeader[];
};
export type ListOfFamily = {
  /** List of the families executions. Source: ECM */
  executions?: {
    /** Execution identifier */
    executionName?: string;
    /** Readable execution name */
    executionDescription?: string;
  }[];
  familyName?: ProductFamilyId;
  /** Readable family name */
  familyDescription?: string;
}[];
export type ListOfMainHeaders = {
  mainHeaderNo?: number;
  /** List of the headers subheaders. Source: ECM */
  listOfSubHeaders?: {
    /** Readable header name */
    subHeaderDescription?: string;
    listOfFamily?: ListOfFamily;
    subHeaderNo?: number;
  }[];
  /** Readable header name */
  mainHeaderDescription?: string;
}[];
export type FamiliesTreeResponseBody = {
  response_type: string;
  listOfMainHeaders: ListOfMainHeaders;
};
export type FamiliesFlatResponseBody = {
  response_type: string;
  listOfFamily?: ListOfFamily;
};
export type AllFamiliesResponse = {
  families_result?: FamiliesTreeResponseBody | FamiliesFlatResponseBody;
};
export type LanguageInfo = {
  isoCountryCode?: CountryIsoCode;
  languageID?: LanguageId;
  /** Textual description of the language */
  languageName?: string;
  languageISOId?: LanguageIsoCode;
};
export type MarketLanguages = {
  listOfLanguage?: LanguageInfo[];
};
export type DddToPpResponse = UnifiedStatusResponse & {
  partPeriod?: Period;
};
export type LegacyManCodeResponse = {
  tg3Code?: LegacyManCode;
};
export type Market = {
  /** Textual market description */
  marketName?: string;
  vehicleTypeID?: VehicleTypeId;
  /** Hints at the country this market represents, but might also not. Some markets have country code XQ, which seems to be some sort of meta-country e.g. for business units */
  isoCountryCode?: string;
  /** Indicates whether this market is an aggregation of sub-markets */
  isBusinessUnit?: boolean;
  /** List of of configuration type IDs that are available for this market. Note that this list is currently not fetched from ECM but is built from static data that might not be up-to-date. */
  configurationTypeIDs?: ConfigTypeId[];
  marketId?: MarketId;
};
export type MarketInfo = {
  /** List of available markets */
  markets?: Market[];
};
export type UserData = {
  userData: object;
};
